import React, { useCallback } from 'react'
import { useNewTranslation } from 'hooks/index'
import { useDispatch, useSelector } from 'react-redux'
import { EditRequestHistoryText } from './styles'
import { openEditRequestHistoryModal, selectSelectedSubmissionView } from 'state/review'
import { SUBMISSION_VIEW_ENUM } from 'state/submissions'
import { TextScale } from 'particles/Text'

export type Size = 's' | 'xs'

interface EditRequestHistoryButtonProps {
    submissionProgressUuid: string
    partiposterId: string
    fontSize?: Size
    className?: string
}

const sizeMap = (): Record<Size, { textScale: TextScale }> => ({
    s: {
        textScale: 'bodyS500',
    },
    xs: {
        textScale: 'caption500',
    },
})

const EditRequestHistoryButton: React.FC<EditRequestHistoryButtonProps> = ({
    submissionProgressUuid,
    partiposterId,
    fontSize,
    className,
}) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const selectedSubmissionView = useSelector(selectSelectedSubmissionView)
    const { textScale } = sizeMap()[fontSize ?? 'xs']
    const showEditRequestHistoryText =
        selectedSubmissionView == SUBMISSION_VIEW_ENUM.BATCH_SUBMISSIONS ||
        selectedSubmissionView == SUBMISSION_VIEW_ENUM.PENDING ||
        selectedSubmissionView == SUBMISSION_VIEW_ENUM.FOR_REVIEW ||
        selectedSubmissionView == SUBMISSION_VIEW_ENUM.EDITS_REQUESTED ||
        selectedSubmissionView == SUBMISSION_VIEW_ENUM.COMPLETED
    const onOpenEditRequestHistoryModal = useCallback(
        e => {
            e.stopPropagation()
            dispatch(
                openEditRequestHistoryModal({
                    isOpen: true,
                    submissionProgressUuid,
                    partiposterId,
                }),
            )
        },
        [submissionProgressUuid, partiposterId, dispatch],
    )

    return showEditRequestHistoryText ? (
        <EditRequestHistoryText
            scale={textScale}
            color="action"
            textAlign="left"
            onClick={onOpenEditRequestHistoryModal}
            className={className}
        >
            {t('button.showEditRequestHistory')}
        </EditRequestHistoryText>
    ) : null
}

export default EditRequestHistoryButton
